import React from 'react';
import PropTypes from 'prop-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

const FaqJsonLd = ({ question: name, answer }) => ({
  '@type': 'Question',
  name,
  acceptedAnswer: {
    '@type': 'Answer',
    text: documentToPlainTextString(answer),
  },
});

const Faq = ({ question, answer }) => (
  <details className="accordion-item" open="">
    <summary className="accordion-summary">
      <span className="accordion-title">{question}</span>
    </summary>
    <div className="accordion-content">{documentToReactComponents(answer)}</div>
  </details>
);

Faq.JSONLD = FaqJsonLd;

Faq.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.shape().isRequired,
};

export default Faq;
